namespace $ { export class $piterjs_speech_page extends $mol_page {

	/**
	 *  ```
	 *  speech $piterjs_speech
	 *  ```
	 **/
	@ $mol_mem
	speech() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_speech(  ) )
	}

	/**
	 *  ```
	 *  minimal_width 600
	 *  ```
	 **/
	minimal_width() {
		return 600
	}

	/**
	 *  ```
	 *  tools / <= Close
	 *  ```
	 **/
	tools() {
		return [this.Close()] as readonly any[]
	}

	/**
	 *  ```
	 *  Close $mol_link
	 *  	arg * speech null
	 *  	sub / <= Close_icon
	 *  ```
	 **/
	@ $mol_mem
	Close() {
		return (( obj )=>{
			obj.arg = () => ({
			"speech" :  null as any ,
		})
			obj.sub = () => [this.Close_icon()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Close_icon $mol_icon_cross
	 *  ```
	 **/
	@ $mol_mem
	Close_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_cross(  ) )
	}

	/**
	 *  ```
	 *  body /
	 *  	<= Description
	 *  	<= Links
	 *  	<= Speaker
	 *  ```
	 **/
	body() {
		return [this.Description() , this.Links() , this.Speaker()] as readonly any[]
	}

	/**
	 *  ```
	 *  Description $mol_text text <= description
	 *  ```
	 **/
	@ $mol_mem
	Description() {
		return (( obj )=>{
			obj.text = () => this.description()
			return obj
		})( new this.$.$mol_text(  ) )
	}

	/**
	 *  ```
	 *  description \
	 *  ```
	 **/
	description() {
		return ""
	}

	/**
	 *  ```
	 *  Links $mol_row sub <= links
	 *  ```
	 **/
	@ $mol_mem
	Links() {
		return (( obj )=>{
			obj.sub = () => this.links()
			return obj
		})( new this.$.$mol_row(  ) )
	}

	/**
	 *  ```
	 *  links /
	 *  	<= Slides
	 *  	<= Video
	 *  ```
	 **/
	links() {
		return [this.Slides() , this.Video()] as readonly any[]
	}

	/**
	 *  ```
	 *  Slides $mol_link
	 *  	uri <= slides
	 *  	title \Слайды
	 *  	target \_blank
	 *  ```
	 **/
	@ $mol_mem
	Slides() {
		return (( obj )=>{
			obj.uri = () => this.slides()
			obj.title = () => "Слайды"
			obj.target = () => "_blank"
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  slides \
	 *  ```
	 **/
	slides() {
		return ""
	}

	/**
	 *  ```
	 *  Video $mol_link
	 *  	uri <= video
	 *  	title \Видео
	 *  	target \_blank
	 *  ```
	 **/
	@ $mol_mem
	Video() {
		return (( obj )=>{
			obj.uri = () => this.video()
			obj.title = () => "Видео"
			obj.target = () => "_blank"
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  video \
	 *  ```
	 **/
	video() {
		return ""
	}

	/**
	 *  ```
	 *  Speaker $piterjs_speaker_snippet speaker <= speaker
	 *  ```
	 **/
	@ $mol_mem
	Speaker() {
		return (( obj )=>{
			obj.speaker = () => this.speaker()
			return obj
		})( new this.$.$piterjs_speaker_snippet(  ) )
	}

	/**
	 *  ```
	 *  speaker $piterjs_speaker
	 *  ```
	 **/
	@ $mol_mem
	speaker() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_speaker(  ) )
	}

} }
